import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import './design-guidelines-styles.css';
export const _frontmatter = {
  "pageTitle": "Character Counter Design Guidelines",
  "title": "Character Counter",
  "order": 1
};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const PageContent = makeShortcode("PageContent");
const LeadParagraph = makeShortcode("LeadParagraph");
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <PageContent componentName="character_counter" type="design" mdxType="PageContent">
      <LeadParagraph mdxType="LeadParagraph">
  Character counter helps users know how much text they can enter when there is
  a limit on the number of characters.
      </LeadParagraph>
      <p><span parentName="p" {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1035px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "33.97683397683397%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAHCAYAAAAIy204AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAf0lEQVQoz6WRyQrEIBBE8//fqSh6EZeLS9dQQxIkZGNGKAqlfV10L6UU5Jyx+VF8v9NaI+tdlhkYQoBSCsYYaK1hrUWM8VJTkHNgSgm1VvTed40xTtVa+0JvgXQRwZtD6COQCZmK0E1/JWSB9x7Oud05Vzb6aYZ0fp71tOnjlj902B5gXmcfiAAAAABJRU5ErkJggg==')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": " ",
            "title": " ",
            "src": "/static/9e8d8df976fd0747a9b46c0e38e3c8b4/e3189/intro-image.png",
            "srcSet": ["/static/9e8d8df976fd0747a9b46c0e38e3c8b4/a2ead/intro-image.png 259w", "/static/9e8d8df976fd0747a9b46c0e38e3c8b4/6b9fd/intro-image.png 518w", "/static/9e8d8df976fd0747a9b46c0e38e3c8b4/e3189/intro-image.png 1035w", "/static/9e8d8df976fd0747a9b46c0e38e3c8b4/aa440/intro-image.png 1500w"],
            "sizes": "(max-width: 1035px) 100vw, 1035px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span></p>
      <h2>{`Usage`}</h2>
      <h3>{`When to use the character counter`}</h3>
      <p><strong parentName="p">{`Keeping it short`}</strong>{` - When users are likely to provide more detail than is needed, and you want to force them to use fewer words. Note: this will likely increase the amount of time it takes users to submit the form because editing requires thinking.`}</p>
      <p><strong parentName="p">{`Legal requirement`}</strong>{` - When there is a legal reason where an entry must be under a certain number of characters.`}</p>
      <h3>{`When to consider a different solution`}</h3>
      <p><strong parentName="p">{`Backend limitations`}</strong>{` - If your users keep hitting the character limit imposed by the backend of your service then try to increase the limit rather than use a character count.`}</p>
      <p><strong parentName="p">{`Already implied`}</strong>{` - If the character length is apparent or implied by the data type (i.e. phone number or zip code).`}</p>
      <p><strong parentName="p">{`Exceeding the character limit is highly unlikely`}</strong>{` - If the vast majority of users are very unlikely to run into backend validation, such as an address field that has a database field limit of 250 characters.`}</p>
      <hr></hr>
      <h2>{`Component Behavior`}</h2>
      <p>{`The character counter initially tells the user the maximum number of characters they are allowed to enter.`}</p>
      <div {...{
        "className": "two-col"
      }}>{`
  `}<div parentName="div" {...{
          "className": "row"
        }}>{`
    `}<div parentName="div" {...{
            "className": "col col-1"
          }}>{`
      `}<figure parentName="div">{`
        `}<span parentName="figure" {...{
                "className": "gatsby-resp-image-wrapper",
                "style": {
                  "position": "relative",
                  "display": "block",
                  "marginLeft": "auto",
                  "marginRight": "auto",
                  "maxWidth": "756px"
                }
              }}>{`
      `}<span parentName="span" {...{
                  "className": "gatsby-resp-image-background-image",
                  "style": {
                    "paddingBottom": "67.18146718146718%",
                    "position": "relative",
                    "bottom": "0",
                    "left": "0",
                    "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAANCAYAAACpUE5eAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAwElEQVQ4y61T0QqDMAz0/7/PN0GoWlREqLXWvpgbKZbpcK7dFjiahvRIk0tmjMGyLODziKvYDWjPpyw8tNZiXVc457zP8QTQXsSTsCxLFEWBPM/RdZ1PnOc5CpcVDsOAvu8hpcQ4jtBaY5qmWJwr5CB/91uz1hJznAi5b2zbtoGIovGR8Jh4Z8mEP1f41x7yhJRSfrKvkggxPt/hNOUg6rZt0TQN6rpGVVUQQngJ8T34SToMqr9bsaRNiVmxmF1+AJ6X76gBzfcjAAAAAElFTkSuQmCC')",
                    "backgroundSize": "cover",
                    "display": "block"
                  }
                }}></span>{`
  `}<img parentName="span" {...{
                  "className": "gatsby-resp-image-image",
                  "alt": "",
                  "title": "",
                  "src": "/static/d3fbf8fffc474f8671b5b5d125c2bfbd/8ae3e/behavior-1.png",
                  "srcSet": ["/static/d3fbf8fffc474f8671b5b5d125c2bfbd/a2ead/behavior-1.png 259w", "/static/d3fbf8fffc474f8671b5b5d125c2bfbd/6b9fd/behavior-1.png 518w", "/static/d3fbf8fffc474f8671b5b5d125c2bfbd/8ae3e/behavior-1.png 756w"],
                  "sizes": "(max-width: 756px) 100vw, 756px",
                  "style": {
                    "width": "100%",
                    "height": "100%",
                    "margin": "0",
                    "verticalAlign": "middle",
                    "position": "absolute",
                    "top": "0",
                    "left": "0"
                  },
                  "loading": "lazy"
                }}></img>{`
    `}</span>{`
      `}</figure>{`
    `}</div>{`
    `}<div parentName="div" {...{
            "className": "col col-2"
          }}>{`
  `}</div>
        </div></div>
      <p>{`As the user types, the character counter updates in real-time and informs the user how many characters they have left.`}</p>
      <div {...{
        "className": "two-col"
      }}>{`
  `}<div parentName="div" {...{
          "className": "row"
        }}>{`
    `}<div parentName="div" {...{
            "className": "col col-1"
          }}>{`
      `}<figure parentName="div">{`
        `}<span parentName="figure" {...{
                "className": "gatsby-resp-image-wrapper",
                "style": {
                  "position": "relative",
                  "display": "block",
                  "marginLeft": "auto",
                  "marginRight": "auto",
                  "maxWidth": "756px"
                }
              }}>{`
      `}<span parentName="span" {...{
                  "className": "gatsby-resp-image-background-image",
                  "style": {
                    "paddingBottom": "67.18146718146718%",
                    "position": "relative",
                    "bottom": "0",
                    "left": "0",
                    "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAANCAYAAACpUE5eAAAACXBIWXMAAAsTAAALEwEAmpwYAAAA4ElEQVQ4y52TSQ6DMAxFe//zsUCMC8QsZgjDIr9yRCiUIU0tPTlx7C+Dk1ff9xiGAeT3XMUe4Gs+f8lCxhjGccQ0TWJNcQ342sRH0PM82LYNwzCQJIlIbNsWXdcpuewwz3OkaYooilCW5SZGXtI0zR3HDqmwqirEcSwSSLgoCuGzLEMYhiJ+Z4wxTueb4LrBsiyY51l4Qv5TGSPjnB+4FaRBqEwK7IWVgt8dqLgVpM/7106CNKG6rk/XZD/hJ05Tpk0QBHAcB6ZpivtoWRZc14Xv++Jc+x4+ofVSfinQectvJkPtFNIkx/AAAAAASUVORK5CYII=')",
                    "backgroundSize": "cover",
                    "display": "block"
                  }
                }}></span>{`
  `}<img parentName="span" {...{
                  "className": "gatsby-resp-image-image",
                  "alt": "",
                  "title": "",
                  "src": "/static/21b3d10220c8e49c89a96e10de6a7e4f/8ae3e/behavior-2.png",
                  "srcSet": ["/static/21b3d10220c8e49c89a96e10de6a7e4f/a2ead/behavior-2.png 259w", "/static/21b3d10220c8e49c89a96e10de6a7e4f/6b9fd/behavior-2.png 518w", "/static/21b3d10220c8e49c89a96e10de6a7e4f/8ae3e/behavior-2.png 756w"],
                  "sizes": "(max-width: 756px) 100vw, 756px",
                  "style": {
                    "width": "100%",
                    "height": "100%",
                    "margin": "0",
                    "verticalAlign": "middle",
                    "position": "absolute",
                    "top": "0",
                    "left": "0"
                  },
                  "loading": "lazy"
                }}></img>{`
    `}</span>{`
      `}</figure>{`
    `}</div>{`
    `}<div parentName="div" {...{
            "className": "col col-2"
          }}>{`
  `}</div>
        </div></div>
      <p>{`When the user exceeds the maximum number of characters allowed, the character counter alerts them with an error and tells the user how many characters over the limit they are.`}</p>
      <div {...{
        "className": "two-col"
      }}>{`
  `}<div parentName="div" {...{
          "className": "row"
        }}>{`
    `}<div parentName="div" {...{
            "className": "col col-1"
          }}>{`
      `}<figure parentName="div">{`
        `}<span parentName="figure" {...{
                "className": "gatsby-resp-image-wrapper",
                "style": {
                  "position": "relative",
                  "display": "block",
                  "marginLeft": "auto",
                  "marginRight": "auto",
                  "maxWidth": "756px"
                }
              }}>{`
      `}<span parentName="span" {...{
                  "className": "gatsby-resp-image-background-image",
                  "style": {
                    "paddingBottom": "67.18146718146718%",
                    "position": "relative",
                    "bottom": "0",
                    "left": "0",
                    "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAANCAYAAACpUE5eAAAACXBIWXMAAAsTAAALEwEAmpwYAAABfElEQVQ4y51TC07DMAzd/U+BxFXgBoBgQwP2S9v85yStYOpD9lrWIcQv0pMTy3l+juNZSgk5Z7Cd4ivfN+iH+H42XiyloG1bdF0ne/b/Af0gop9lzpAzlsslFvM5bm9uUFWVBNJ+DyJCIhI7Ik3AMV8q9ErBbTfQqxdQU6N1Dp13YouzYkcUa5GNET/HZGtPClldjhHZGtRaiwKtNUIIMMZAGwNVVXLe7XbYbLeIMQqapkFjDLoY+hQCcimDwhhB9niZyawxqOtaLjjnjrBWCJmIE3EC9r2+HfCWqKfgp4QBZAyquhZCJquHPcN7LyT8trxXSh1j+K1LQRfjSWEaFRqNnVIfJNZasayKla7Xa1E6ko8JtLWfSi4F5D0ObYv/LinZT0vmr7NaoVTVsZPenXVVzpY7fY4yWu4y0dBlIpTDAeryAub6CnG9gr+7hX+4F8TnJ4THBcLTEmExR6L92T8UTP/hx5iFMIzcMHrpZM/w46QMJedfjttPs/wO+gPhgxPcCjkAAAAASUVORK5CYII=')",
                    "backgroundSize": "cover",
                    "display": "block"
                  }
                }}></span>{`
  `}<img parentName="span" {...{
                  "className": "gatsby-resp-image-image",
                  "alt": "",
                  "title": "",
                  "src": "/static/2d223b23abb6c7cb6ff7db9084469243/8ae3e/behavior-3.png",
                  "srcSet": ["/static/2d223b23abb6c7cb6ff7db9084469243/a2ead/behavior-3.png 259w", "/static/2d223b23abb6c7cb6ff7db9084469243/6b9fd/behavior-3.png 518w", "/static/2d223b23abb6c7cb6ff7db9084469243/8ae3e/behavior-3.png 756w"],
                  "sizes": "(max-width: 756px) 100vw, 756px",
                  "style": {
                    "width": "100%",
                    "height": "100%",
                    "margin": "0",
                    "verticalAlign": "middle",
                    "position": "absolute",
                    "top": "0",
                    "left": "0"
                  },
                  "loading": "lazy"
                }}></img>{`
    `}</span>{`
      `}</figure>{`
    `}</div>{`
    `}<div parentName="div" {...{
            "className": "col col-2"
          }}>{`
  `}</div>
        </div></div>
      <hr></hr>
      <h2>{`Accessibility`}</h2>
      <p>{`The following measures have been taken to ensure the Character Counter component is accessible.`}</p>
      <ol>
        <li parentName="ol">{`The character count message is associated with the input. We use `}<inlineCode parentName="li">{`aria-describedby`}</inlineCode>{` on the input to allow the message to be announced to those using screen readers.`}</li>
        <li parentName="ol">{`We use the aria-live attribute on the character count message. We use `}<inlineCode parentName="li">{`aria-live="polite"`}</inlineCode>{` so that updates to the character count message are also announced when using a screen reader.`}</li>
      </ol>
    </PageContent>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      